import { Column, Image } from "@hex-insights/core";
import { StaticURLs } from "@hex-insights/verita-romania.shared";
import { Main } from "../../../Components";
import generalStyles from "../authentication.module.css";
import styles from "./styles.module.css";

export function SplashPage() {
	return (
		<Main className={generalStyles["auth-page__main"]}>
			<Column justify="center" align="center">
				<Image src={StaticURLs.Images.veritaWingsSymmetricMedium} sizing="contain" className={styles["image"]} />
			</Column>
		</Main>
	);
}
